import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import HomeModel from "../../models/HomeModel";
import Swal from "sweetalert2";
import VietQrModel from "../../models/VietQrModel";
import { FaDoorClosed, FaTimes, } from "react-icons/fa";

function ModalACB(props) {
  const [modalShow, setModalShow] = React.useState(false);
  const [data, setData] = useState([]);
  const [bank, setBank] = useState([]);
  useEffect(() => {
    HomeModel.getInfoHeader()
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});

    VietQrModel.getOwnerBank("MB")
      .then((res) => {
        setBank(res.data);
      })
      .catch((err) => {});
  }, []);
  const handleCloseModal = () => {
    setModalShow(false);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(bank.account_number);
    Swal.fire({
      icon: "success",
      title: "Đã copy số tài khoản!",
      showConfirmButton: false,
      timer: 1000,
    });
  };
  const copyToClipboardTransactionCode = () => {
    navigator.clipboard.writeText(`user ${data.user_name} payment`);
    Swal.fire({
      icon: "success",
      title: "Đã copy nội dung chuyển khoản!",
      showConfirmButton: false,
      timer: 1000,
    });
  };
  const imageQR = localStorage.getItem("imageQR");
  // const [dataCheck, setDataCheck] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      HomeModel.getInfoHeader()
        .then((res) => {
          // setDataCheck(res.data);
          if (res.data.account_balance > data.account_balance) {
            Swal.fire({
              icon: "success",
              title: "Nạp tiền thành công!",
              showConfirmButton: false,
            });
            setTimeout(() => {
              reloadPage();
            }, 2000);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }, 5000);

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(interval);
  }, [data]);

  const reloadPage = () => {
    window.location.reload();
  };
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // style={{width:'500px', display:'flex' , justifyContent:'center'}}
      >
        <Modal.Header
          style={{
            backgroundColor: "#f8f9fa",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ color: "#000000", fontWeight: "600" }}
          >
            Nạp tiền tự động qua MB
          </Modal.Title>
          <button
            type="button"
            onClick={props.onHide}
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              color: "#000000",
              opacity: "0.7",
              cursor: "pointer",
              padding: "0",
              marginLeft: "auto",
            }}
            aria-label="Close"
          ><FaTimes/></button>
        </Modal.Header>
        <Modal.Body style={{ padding: "20px" }}>
          <div
            className="alert alert-warning mt-0 mb-4"
            role="alert"
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeaa7",
              color: "#856404",
              borderRadius: "8px",
              padding: "15px",
            }}
          >
            <div className="alert-body d-flex justify-content-center">
              <span style={{ fontSize: "14px", lineHeight: "1.5" }}>
                <strong>*Lưu ý:</strong> Nhập đúng nội dung chuyển khoản.
                <br /> Tiền sẽ được tự động cộng vào tài khoản trong tối đa 5
                phút
              </span>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              padding: "20px",
            }}
          >
            {/* QR Code Section */}
            <div className="text-center mb-4">
              <div
                className="mb-3"
                style={{
                  color: "#007bff",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                Chuyển khoản bằng mã QR
              </div>
              <div
                className="mb-3"
                style={{ color: "#000000", fontSize: "14px" }}
              >
                Mở app ngân hàng quét mã QRCode
              </div>
              <div className="d-flex justify-content-center">
                <div
                  style={{
                    width: "200px",
                    height: "200px",
                    border: "2px solid #e0e0e0",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <img
                    src={imageQR}
                    width={180}
                    height={180}
                    style={{ borderRadius: "4px" }}
                  />
                </div>
              </div>
            </div>

            {/* Bank Information Section */}
            <div className="mb-3">
              <div className="mb-2">
                <span style={{ color: "#000", fontWeight: "600" }}>
                  Ngân hàng:
                </span>
                <span style={{ color: "#000000", marginLeft: "8px" }}>
                  Ngân hàng {bank.description}
                </span>
              </div>
              <div className="row mb-2 align-items-center">
                <div className="col-9">
                  <span style={{ color: "#000", fontWeight: "600" }}>
                    Số tài khoản:
                  </span>
                  <span style={{ color: "#000000", marginLeft: "8px" }}>
                    {bank.account_number}
                  </span>
                </div>
                <div className="col-3 text-center p-0">
                  <button
                    onClick={copyToClipboard}
                    style={{
                      height: "24px",
                      width: "60px",
                      borderRadius: "6px",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    Copy
                  </button>
                </div>
              </div>
              <div className="mb-2">
                <span style={{ color: "#000", fontWeight: "600" }}>
                  Tên tài khoản:
                </span>
                <span style={{ color: "#000000", marginLeft: "8px" }}>
                  {bank.account_name}
                </span>
              </div>
              <div className="row align-items-center">
                <div className="col-9">
                  <span style={{ color: "#000", fontWeight: "600" }}>
                    Nội dung CK:
                  </span>
                  <span
                    style={{
                      color: "#000000",
                      marginLeft: "8px",
                      fontWeight: "500",
                    }}
                  >
                    user {data.user_name} payment
                  </span>
                </div>
                <div className="col-3 text-center p-0">
                  <button
                    onClick={copyToClipboardTransactionCode}
                    style={{
                      height: "24px",
                      width: "60px",
                      borderRadius: "6px",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalACB;
